const form = document.querySelector('.js-form-giving');

let amountInput = null,
    reasonInput = null,
    submit = null;

export function init() {
    if (!form) {
        return;
    }

    amountInput = form.querySelector('input[name="amount"]');
    reasonInput = form.querySelector('textarea[name="whatPromptedYouToGive"]');
    submit = form.querySelector('button[type="submit"]');
}
